import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShareDetailsForm } from '../ShareDetailsForm';

export function ViewShareforHold() {
  const { state } = useLocation();
  const navigate = useNavigate();
  
  const [registrationData, setRegistrationData] = useState(null);
  const [selectedShares, setSelectedShares] = useState(state?.shares || "1"); 

  useEffect(() => {
    // 1. Guard Clause
    if (!state) {
      navigate(-1);
      return;
    }

    // 2. Explicitly Mapping Particular Fields
    // This ensures 'animalType' from the previous page becomes 'type' for the next form
    const mappedData = {
      // Spread existing API data if available
      ...(state.registrationData || {}),
      
      // Force set specific fields from the navigation state
      type: state.animalType,           // Mapping animalType -> type
      category: state.subcate,          // Mapping subcate -> category
      animalNo: state.autoFilter,       // Mapping autoFilter -> animalNo
      slaughteringDay: state.day,       // Mapping day -> slaughteringDay
      shares: state.shares,
      
      // User Info
      customerName: state.registrationData?.customer_name || localStorage.getItem('customerName'),
      phone: state.registrationData?.phone || localStorage.getItem('phone'),
      email: state.registrationData?.email || localStorage.getItem('userEmail'),
      
      // ID for the database record
      registrationId: state.registrationData?.id || state.registrationData?._id
    };

    setRegistrationData(mappedData);
    
    if (state.shares) {
      setSelectedShares(state.shares);
    }
  }, [state, navigate]);

  if (!registrationData) {
    return <div className="p-10 text-center">Loading form fields...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto mt-8 px-4">
      {/* Header Summary */}
      <div className="bg-green-50 border border-green-200 p-4 rounded-lg mb-8 flex justify-between items-center">
        <div>
          <p className="text-xs font-bold text-green-700 uppercase">Selected Animal</p>
          <h2 className="text-xl font-bold text-gray-800">
            {registrationData.type} — Tag #{registrationData.animalNo}
          </h2>
          <p className="text-sm text-gray-600">
            Category: {registrationData.category} | Day: {registrationData.slaughteringDay}
          </p>
        </div>
        <div className="text-right">
          <p className="text-xs font-bold text-gray-400 uppercase">Share Count</p>
          <p className="text-3xl font-black text-gray-800">{selectedShares}</p>
        </div>
      </div>

      {/* The main form that now receives 'type', 'category', etc. */}
      <ShareDetailsForm 
        shares={selectedShares} 
        registrationData={registrationData} 
      />
    </div>
  );
}